import axiosInstance from "../axiosInstance";

export const PUTAbrirPalet = async (idomau, idpale) => {
  try {
    const response = await axiosInstance.put(
      `${process.env.REACT_APP_WMS_BASE_URL}/ordenes/palet/abrir`,
      null,
      {
        params: {
          idomau,
          idpale,
        },
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    return {
      status: error.response?.status,
      data: error.response?.data,
      message: error.response?.data?.message || "Error al abrir el palet",
    };
  }
};

export default PUTAbrirPalet;
